import { h, Component } from "preact";
import { connect } from "react-redux";

import { css } from "emotion";

import OrganiserBanner from "./OrganiserBanner";
import OrganiserInfo from "./OrganiserInfo";
import OrganiserCharities from "./OrganiserCharities";
import OrganiserEvents from "./OrganiserEvents";
import { scrollToId } from "../../utils/ScrollTo";

import {
  getOrganiser,
  changeTab,
  loadLiveEventsByOrganiser,
  loadPastEventsByOrganiser
} from "../../state/actions/organiserActions";

import { pageChange } from "../../utils/BrowserUtils";
import OrganiserSocial from "./OrganiserSocial";

const content = css`
  background-color: #f9f9fa;
`;

const wrapperDiv = css`
  max-width: 1000px;
  display: block;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 38px;
  background-color: #f9f9fa;
  &:after {
    content: "";
    display: block;
    clear: both;
  }

  @media (max-width: 1000px) {
    padding-left: 14px;
    padding-right: 14px;
  }
`;

const desktop = css`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;

const left = css`
  max-width: 280px;
  margin-right: 20px;
`;
const right = css`
  max-width: 700px;
  width: 100%;
`;

const mobile = css`
  background-color: #f9f9fa;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const eventsWrapper = css({
  marginBottom: 60,
  "@media(max-width: 800px)": {
    marginBottom: 24
  }
});

class Organiser extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.switchTab = this.switchTab.bind(this);
    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    const { organiserId, getOrganiser, organiser } = this.props;
    getOrganiser(organiserId);
    this.loadPage(organiser.tab, 0);
  }

  componentWillUpdate(nextProps) {
    const { organiser } = this.props;
    if (organiser.organiser) {
      pageChange(organiser.organiser.name);
    }
  }

  nextPage() {
    const { organiser } = this.props;
    const tab = organiser.tab;
    const eventList =
      tab === "live" ? organiser.liveEvents : organiser.pastEvents;
    const page = eventList.page;
    this.scrollToList();
    this.loadPage(tab, page + 1);
  }

  previousPage() {
    const { organiser } = this.props;
    const tab = organiser.tab;
    const eventList =
      tab === "live" ? organiser.liveEvents : organiser.pastEvents;
    const page = eventList.page;
    if (page !== 0) {
      this.scrollToList();
      this.loadPage(tab, page - 1);
    }
  }

  scrollToList() {
    const size = window.innerWidth < 600 ? "small" : "large";
    scrollToId(`event-list-${size}`, 0, 0);
  }

  switchTab(tab) {
    const { changeTab } = this.props;
    changeTab(tab);
    this.loadPage(tab);
  }

  loadPage(tab, page) {
    const {
      organiserId,
      organiser,
      loadLiveEventsByOrganiser,
      loadPastEventsByOrganiser
    } = this.props;
    let loadAction = loadPastEventsByOrganiser;
    let eventList = organiser.pastEvent;
    if (tab === "live") {
      loadAction = loadLiveEventsByOrganiser;
      eventList = organiser.liveEvent;
    }
    const loadPage = page !== null ? page : eventList.page;

    loadAction(organiserId, loadPage, tab);
  }

  render() {
    const { organiser, tab, liveEvents, pastEvents } = this.props.organiser;
    const eventList = tab === "live" ? liveEvents : pastEvents;
    const Info = () => {
      return (
        <OrganiserInfo
          name={organiser.name}
          description={organiser.description}
          twitter={organiser.twitter}
          facebook={organiser.facebook}
          instagram={organiser.instagram}
        />
      );
    };

    const EventsList = ({ size }) => {
      return (
        <OrganiserEvents
          events={eventList.events}
          nextPage={this.nextPage}
          previousPage={this.previousPage}
          tab={tab}
          changeTab={this.switchTab}
          page={eventList.page}
          numEvents={eventList.total}
          loadingEvents={eventList.loading}
          size={size}
        />
      );
    };

    if (organiser) {
      const logoUrl = organiser.logo ? organiser.logo.url : null;
      return (
        <div className={content}>
          <div className={wrapperDiv}>
            <OrganiserBanner
              backgroundColor={organiser.bannerBackground}
              logo={logoUrl}
              name={organiser.name}
              website={organiser.website}
            />
            <div className={desktop}>
              <div className={left}>
                <Info />
                <OrganiserSocial
                  twitter={organiser.twitter}
                  facebook={organiser.facebook}
                  instagram={organiser.instagram}
                  linkedIn={organiser.linkedIn}
                />
              </div>
              <div className={right}>
                <EventsList size="large" />
              </div>
            </div>
            <div className={mobile}>
              <Info />
              <div className={eventsWrapper}>
                <EventsList size="small" />
              </div>
              <OrganiserSocial
                twitter={organiser.twitter}
                facebook={organiser.facebook}
                instagram={organiser.instagram}
                linkedIn={organiser.linkedIn}
              />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default connect(
  (state, ownProps) => ({ organiser: state.organiser }),
  {
    getOrganiser,
    loadLiveEventsByOrganiser,
    loadPastEventsByOrganiser,
    changeTab
  }
)(Organiser);



// WEBPACK FOOTER //
// ./routes/organiser/Organiser.js